import React from 'react'
import { Link } from 'react-router-dom'
import './ProjectCard.css'
import { getTagStyle } from '../utils/tagColors'

export default function ProjectCard(props) {
	const { link, imagePath, name, tags = [] } = props;
	return (
		<Link className='ProjectCard' to={link}>
			<img src={imagePath} alt={name + ' thumbnail'} />
			<p className='card-name'>
				<span className='card-name-text'>{name}</span>
				{tags && tags.length > 0 && (
					<ul className="badges" aria-label="Project tags">
						{tags.map((t, i) => (
							<li className="badge" key={i} style={getTagStyle(t)}>{t}</li>
						))}
					</ul>
				)}
			</p>
		</Link>
	)
}
